var React = require('react');

function StepBulle (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M103.576,119.53C76.656,85.589,8.19,92.247,4.809,46.938C2.552,10.81,76.421,2.779,100.103,11.956\r\n\t\tc9.58,4.018,23.684,16.631,23.122,28.672c0,16.065-19.303,27.774-25.532,39.799C92.058,91.323,94.415,107.974,103.576,119.53z"})));
}

StepBulle.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","width":"128px","height":"128px","viewBox":"0 0 128 128","enableBackground":"new 0 0 128 128","xmlSpace":"preserve"};

module.exports = StepBulle;

StepBulle.default = StepBulle;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/step-bulle.svg
// module id = 426
// module chunks = 0